var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "verticalCenter", staticStyle: { "margin-top": "0" } },
      [
        _vm._l(_vm.$store.state.forum.messages, function(item) {
          return _c(
            "div",
            { key: item.id },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !item.hide,
                      expression: "!item.hide"
                    }
                  ],
                  staticClass: "forumMessageBlock mb-4",
                  style: { "padding-left": item.messageTier + "%" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "forumArticle" },
                    [
                      _c("div", { staticClass: "forumAuthor" }, [
                        item.userPage
                          ? _c(
                              "a",
                              {
                                staticClass: "underlined bold",
                                attrs: {
                                  target: "_blank",
                                  href: item.userPage
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(item.authorName))]
                            )
                          : _c("span", {
                              domProps: { innerHTML: _vm._s(item.authorName) }
                            }),
                        _vm._v(" "),
                        item.userSpeciality
                          ? _c("span", [
                              _vm._v("\r\n                  ("),
                              item.userPage
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "underlined bold",
                                      attrs: {
                                        target: "_blank",
                                        href: item.userPage
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("consultationIn")) + " "
                                      ),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            item.userSpeciality[
                                              _vm.normalizeForumProp("name")
                                            ]
                                          )
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(")\r\n                ")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getTimeAgoFromDate(item.createdAt)
                            )
                          }
                        }),
                        _vm._v(" "),
                        item.edited
                          ? _c("span", [
                              _vm._v("(" + _vm._s(_vm.$t("edited")) + ")")
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      item.active
                        ? _c("span", {
                            staticClass: "messageBox mx-3",
                            domProps: { innerHTML: _vm._s(item.message) }
                          })
                        : _c(
                            "p",
                            {
                              staticClass: "messageBox mx-3",
                              staticStyle: { "font-style": "italic" }
                            },
                            [_vm._v(_vm._s(_vm.$t("messageDeleted")))]
                          ),
                      _vm._v(" "),
                      !_vm.hideOptions && item.active
                        ? _c(
                            "b-row",
                            { staticClass: "forumFooter" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "py-2",
                                  attrs: { cols: "3", sm: "3" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.answerMessage(item.id)
                                    }
                                  }
                                },
                                [
                                  _c("b-icon-chat-left", {
                                    staticClass: "margin-right-icon"
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "hide-title-mobile" },
                                    [_vm._v(_vm._s(_vm.$t("answer")))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "py-2",
                                  attrs: { cols: "3", sm: "3" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.messageLike(item.id)
                                    }
                                  }
                                },
                                [
                                  _vm.$store.state.forum.userBasicInfo.messagesLike.includes(
                                    item.id
                                  )
                                    ? _c("b-icon-hand-thumbs-up-fill", {
                                        staticClass:
                                          "opensalud-blue margin-right-icon"
                                      })
                                    : _c("b-icon-hand-thumbs-up", {
                                        staticClass: "margin-right-icon"
                                      }),
                                  _c(
                                    "span",
                                    { staticClass: "hide-title-mobile" },
                                    [_vm._v(_vm._s(_vm.$t("like")))]
                                  ),
                                  item.likes
                                    ? _c("span", [
                                        _c(
                                          "span",
                                          { staticClass: "hide-title-mobile" },
                                          [_vm._v(": ")]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "opensalud-blue" },
                                          [_vm._v(_vm._s(item.likes))]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "py-2",
                                  attrs: { cols: "3", sm: "3" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.saveMessage(item.id)
                                    }
                                  }
                                },
                                [
                                  _vm.$store.state.forum.userBasicInfo.messagesSaved.includes(
                                    item.id
                                  )
                                    ? _c("b-icon-bookmark-check-fill", {
                                        staticClass:
                                          "opensalud-blue margin-right-icon"
                                      })
                                    : _c("b-icon-bookmark", {
                                        staticClass: "margin-right-icon"
                                      }),
                                  _c(
                                    "span",
                                    { staticClass: "hide-title-mobile" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.state.forum.userBasicInfo.messagesSaved.includes(
                                            item.id
                                          )
                                            ? _vm.$t("saved")
                                            : _vm.$t("save")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "py-2",
                                  attrs: {
                                    id: "more-options-message-" + item.id,
                                    cols: "3",
                                    sm: "3"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  }
                                },
                                [
                                  _c("b-icon-three-dots", {
                                    attrs: { scale: "1.5" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.messageIdSelected === item.id
                        ? _c(
                            "div",
                            [
                              _c("vue-editor", {
                                attrs: { useCustomImageHandler: "" },
                                on: { "image-added": _vm.handleImageAdded },
                                model: {
                                  value: _vm.wysiwygInput,
                                  callback: function($$v) {
                                    _vm.wysiwygInput = $$v
                                  },
                                  expression: "wysiwygInput"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "base-button",
                                {
                                  staticStyle: { margin: "2% 0" },
                                  on: {
                                    click: function($event) {
                                      return _vm.sendMessage(
                                        item.messageReferenceId
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("send")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "base-button",
                                {
                                  staticStyle: { margin: "2% 0" },
                                  attrs: { gray: "", outline: "" },
                                  on: { click: _vm.goBack }
                                },
                                [_vm._v(_vm._s(_vm.$t("cancel")))]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-popover",
                    {
                      attrs: {
                        target: "more-options-message-" + item.id,
                        triggers: "click",
                        placement: "top"
                      }
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "more-options-row" },
                        [
                          _c(
                            "b-col",
                            {
                              attrs: {
                                cols: "12",
                                id: "share-socials-message-popover-" + item.id
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "more-options-item" },
                                [
                                  _c("b-icon-share", {
                                    staticClass: "margin-right-icon"
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "hide-title-mobile" },
                                    [_vm._v(_vm._s(_vm.$t("share")))]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.canEditForumMessage(item.id) && item.active
                            ? _c(
                                "b-col",
                                {
                                  attrs: { cols: "12" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return function() {
                                        _vm.wysiwygInput = item.message
                                        _vm.messageIdSelected = item.id
                                        _vm.editingMessage = true
                                        _vm.$root.$emit("bv::hide::popover")
                                      }.apply(null, arguments)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "more-options-item" },
                                    [
                                      _c("b-icon-pencil-square", {
                                        staticClass: "margin-right-icon"
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "hide-title-mobile" },
                                        [_vm._v(_vm._s(_vm.$t("edit")))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canModifyForumMessage(item.id) && item.active
                            ? _c(
                                "b-col",
                                {
                                  attrs: { cols: "12" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return function() {
                                        _vm.showConfirmDelete = true
                                        _vm.messageIdToRemove = item.id
                                        _vm.$root.$emit("bv::hide::popover")
                                      }.apply(null, arguments)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "more-options-item" },
                                    [
                                      _c("b-icon-trash", {
                                        staticClass: "margin-right-icon"
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "hide-title-mobile" },
                                        [_vm._v(_vm._s(_vm.$t("remove")))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.aspIdPublisher !=
                          _vm.$store.state.forum.userBasicInfo.userAspId
                            ? _c(
                                "b-col",
                                {
                                  attrs: { cols: "12" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return function() {
                                        _vm.showReportModal = true
                                        _vm.messageIdToReport = item.id
                                        _vm.$root.$emit("bv::hide::popover")
                                      }.apply(null, arguments)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "more-options-item" },
                                    [
                                      _c("b-icon-exclamation-circle", {
                                        staticClass: "margin-right-icon"
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "hide-title-mobile" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("reportMessage"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("social-sharing-popover", {
                            attrs: {
                              url: _vm.shareMessageLink(),
                              targetId:
                                "share-socials-message-popover-" + item.id,
                              sectionName: _vm.getForumSectionTitle(
                                _vm.$store.state.forum.sectionId,
                                true
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showValidateMessage
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "2%" } },
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { green: "" },
                              on: {
                                click: function($event) {
                                  return _vm.validateMessage(item.id, true)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("validate")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "base-button",
                            {
                              attrs: { red: "" },
                              on: {
                                click: function($event) {
                                  return _vm.validateMessage(item.id, false)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("reject")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showReportMessage
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "2%" } },
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { green: "" },
                              on: {
                                click: function($event) {
                                  return _vm.validateReportedMessageAction(
                                    item.id,
                                    true
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("noRemove")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "base-button",
                            {
                              attrs: { red: "" },
                              on: {
                                click: function($event) {
                                  return _vm.validateReportedMessageAction(
                                    item.id,
                                    false
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("remove")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hideOptions
                    ? _c("div", [
                        item.numReplies &&
                        !_vm.$store.state.forum.showMoreIds.find(function(i) {
                          return i === item.id
                        })
                          ? _c(
                              "div",
                              { staticClass: "seeMoreReplies" },
                              [
                                _c("b-icon", {
                                  staticClass: "pointer",
                                  attrs: { icon: "arrow-down", scale: "0.7" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showMoreMessages(item.id)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.showMoreMessages(item.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("show")) +
                                        " " +
                                        _vm._s(item.numReplies) +
                                        " " +
                                        _vm._s(
                                          item.numReplies === 1
                                            ? _vm.$t("moreReply")
                                            : _vm.$t("moreReplies")
                                        )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$store.state.forum.showMoreIds.find(function(i) {
                          return i === item.id
                        })
                          ? _c(
                              "div",
                              { staticClass: "seeLessReplies" },
                              [
                                _c("b-icon", {
                                  staticClass: "pointer",
                                  attrs: { icon: "arrow-up", scale: "0.7" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showLessMessages(item.id)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.showLessMessages(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("hideMessages")))]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("social-sharing-popover", {
                attrs: {
                  url: _vm.shareMessageLink(),
                  targetId: "share-socials-message-" + item.id,
                  sectionName: _vm.getForumSectionTitle(
                    _vm.$store.state.forum.sectionId,
                    true
                  )
                }
              })
            ],
            1
          )
        }),
        _vm._v(" "),
        _c("base-dialog", {
          attrs: {
            value: _vm.showConfirmDelete,
            okFn: function() {
              _vm.removeMessage()
              _vm.showConfirmDelete = false
            },
            cancelFn: function() {
              _vm.showConfirmDelete = false
            },
            okBtnText: _vm.$t("yes"),
            cancelBtnText: _vm.$t("no"),
            content: _vm.$t("removeMessageAdvice")
          }
        }),
        _vm._v(" "),
        _c(
          "base-modal",
          {
            attrs: {
              value: _vm.showReportModal,
              title: _vm.$t("reportMessageTitle")
            },
            on: { hidden: _vm.resetReportModal }
          },
          [
            _c("b-form-textarea", {
              attrs: { rows: 10, "no-resize": true },
              model: {
                value: _vm.reportReasons,
                callback: function($$v) {
                  _vm.reportReasons = $$v
                },
                expression: "reportReasons"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "my-4 text-center" },
              [
                _c(
                  "base-button",
                  { staticClass: "btn-control", on: { click: _vm.sendReport } },
                  [_vm._v(_vm._s(_vm.$t("send")))]
                ),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "back-btn btn-control",
                    attrs: { gray: "", outline: "" },
                    on: { click: _vm.resetReportModal }
                  },
                  [_vm._v(_vm._s(_vm.$t("back")))]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        !_vm.hideOptions
          ? _c("div", { staticClass: "forumMessageBlock" }, [
              _vm.showMorePrincipalMessages
                ? _c(
                    "div",
                    { staticClass: "seeMoreAnswers my-4" },
                    [
                      _c("b-icon", {
                        staticClass: "pointer",
                        attrs: { icon: "arrow-down", scale: "0.7" },
                        on: { click: _vm.loadMorePrincipalMessages }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "pointer",
                          on: { click: _vm.loadMorePrincipalMessages }
                        },
                        [_vm._v(_vm._s(_vm.$t("showMoreReplies")))]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25bba162", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25bba162","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-community/forum/ForumMessageBlock.vue
// module id = 1734
// module chunks = 116